import { Elements } from '@stripe/react-stripe-js';
import { Stripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useOptionalSession } from 'src/contexts/SessionContext';
import { loadStripe } from 'src/models/cart/utils';
import { PosType } from 'src/models/pos-configuration/_types';

import { PosProvider } from './PosContext';
import PosLayout from './PosLayout';

export default function PosPage({ posType }: { posType: PosType }) {
  const { configId, cardReaderId } = useParams<{
    locationId: string;
    configId: string;
    cardReaderId: string;
  }>();
  const [stripePromise, setStripePromise] =
    useState<Promise<Stripe | null> | null>(null);
  const { session } = useOptionalSession();
  const { locationId } = useParams<{
    locationId: string;
  }>();

  useEffect(() => {
    if (session && !stripePromise) {
      setStripePromise(loadStripe(session));
    }
  }, [session, stripePromise]);

  return (
    <Elements stripe={stripePromise}>
      <PosProvider
        posLocationId={locationId!}
        configId={configId!}
        cardReaderId={cardReaderId!}
        posType={posType}
      >
        <PosLayout />
      </PosProvider>
    </Elements>
  );
}
